import {
  LIC_QUEUE_LOAD,
  LIC_QUEUE_UPDATE,
  LIC_QUEUE_ERROR,
  LIC_DOCTOR_STATE_SET,
  LIC_CALL_STARTED,
} from '../actions/licQueue';

const defaultState = {
  stats: {},
  queue: [],
  doctors: [],
  doctorStatus: null,
  assignedCase: null,
  activeCall: null,
  error: null,
};

export default function licQueue(state = defaultState, action) {
  switch (action.type) {
    case LIC_QUEUE_LOAD:
    case LIC_QUEUE_UPDATE:
      return {
        ...state,
        stats: action.payload.stats || state.stats,
        queue: action.payload.queue || state.queue,
        doctors: action.payload.doctors || state.doctors,
        error: null,
      };

    case LIC_DOCTOR_STATE_SET:
      return {
        ...state,
        doctorStatus: action.payload.doctorStatus || state.doctorStatus,
        assignedCase: action.payload.assignedCase,
        error: null,
      };

    case LIC_CALL_STARTED:
      return {
        ...state,
        activeCall: action.payload,
        doctorStatus: { ...(state.doctorStatus || {}), status: 'IN_CALL' },
      };

    case LIC_QUEUE_ERROR:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
